let config = {
    title: `Demon Hunter: Blade's Echo`,
    copyright: '© 2024 MG PLAYGAME',
    policy: 'https://demonhunterbe.com/privacy_policy.html',
    term: 'https://demonhunterbe.com/terms.html',
    introduceTitle: [
        `In "Demon Slayer: Blade's Echo," you will become a member of the Demon Slayer Corps, steadfastly pushing forward to protect your loved ones, uphold justice, and confront the demons occupying our world. As the sun rises, the day of reckoning draws near.`,
    ],
    introduceText: [
        {
            title: '---Combat and Adventure---',
            text: [
                'Experience intense battles and adventurous journeys, with dazzling skill effects and cooperative combat methods, offering you a whole new gameplay experience.'
            ]
        },
        {
            title: '---Exquisite 3D Modeling and Battle Scenes---',
            text: [
                'The game is crafted in 3D mode with diverse combat scenes, providing an ultimate artistic enjoyment and making your exploration journey not dull anymore.'
            ]
        },
        {
            title: '---Anime Style---',
            text: [
                'Presented in a Japanese anime style, immerse yourself in every chapter of the game’s main storyline.'
            ]
        },
        {
            title: '---Diverse Gameplay---',
            text: [
                'Beginner trials aid rapid growth, training assessments understand diverse combinations!'
            ]
        }
    ]
}
export default config;